import React, { useState } from 'react';
import { Button, SaveButton, useCreate, useNotify, FormWithRedirect, SimpleForm, TextInput, required, regex } from 'react-admin';
import { Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CustomLabelInput from '../components/CustomLabelInput';
import NewContactIcon from '@material-ui/icons/PermContactCalendar';

function phoneNumberFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];   
    } else if (phoneNumberString.length >= 14) {
        return phoneNumberString.substring(0, 14)
    } else {
        return phoneNumberString.substring(0, 14)
    } 
}

function ContactAdd({ record, onChange }) {
    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate('contacts');
    const notify = useNotify();

    const handleClick = () => { setShowDialog(true); };
    const handleCloseClick = () => { setShowDialog(false); };

    const handleSubmit = location_id =>
        async values => {
            var {
                display_name,
                phone,
                email,
                notes
            } = values;

            create(
                {
                    payload: {
                        data: {
                            "display_name": display_name,
                            "phone": phone,
                            "notes": notes,
                            "email": email
                        }
                    }
                },
                {
                    onSuccess: () => {
                        setShowDialog(false);
                        onChange();
                    },
                    onFailure: (error) => notify(`Error: ${error.message}`, 'warning'),
                }
            );
        };


    return (
        <>
            <Button className="btn btn-light btn-sm text-danger m-0 p-0 mb-1" style={{ fontSize: '0.80em' }} onClick={handleClick} label="Add">
                <AddIcon className="m-0" />
            </Button>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Create Contact"
            >
                <DialogTitle>
                    <Grid container direction="row" justify="content-between" className="m-0 p-0">
                        <h4 className="p-0 text-danger mx-0" style={{ marginLeft: '-8px' }}><NewContactIcon style={{ fontSize: '32px' }} /> New Contact</h4>
                        <Grid item style={{ marginLeft: "auto" }}>
                            <CloseIcon item
                                onClick={handleCloseClick}
                                disabled={loading}
                                style={{ cursor: "pointer", color: "gray" }}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>

                <FormWithRedirect
                    resource="contacts"
                    save={handleSubmit(record.id)}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <div>
                            <DialogContent className="m-2 p-2 mb-0 pb-0">
                                <div className="row row-cols-2 g-2">
                                    <div>
                                        <TextInput validate={required()} fullWidth className="m-0 p-0" source="display_name" label={<CustomLabelInput label="Name" />} variant="outlined" />
                                    </div>
                                    <div>
                                        <TextInput validate={regex(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Must be (000) 000-0000')} placeholder="(000) 000-0000" parse={phoneNumberFormat} validate={required()} fullWidth className="m-0 p-0" source="phone" label={<CustomLabelInput label="Phone" />} variant="outlined" />
                                    </div>
                                    <div className="w-100">
                                        <TextInput validate={required()} fullWidth className="m-0 p-0" source="email" label={<CustomLabelInput label="Email" />} variant="outlined" />
                                    </div>
                                </div>
                            </DialogContent>

                            <DialogActions>
                                <div className="p-2 pb-3 d-flex justify-content-start w-100">
                                    <SaveButton
                                        className="mx-2"
                                        label="Add New Contact"
                                        handleSubmitWithRedirect={
                                            handleSubmitWithRedirect
                                        }
                                        pristine={pristine}
                                        saving={saving}
                                        disabled={loading}
                                    />
                                </div>
                            </DialogActions>
                        </div>
                    )}
                />
            </Dialog>
        </>
    );
}

export default ContactAdd;
